export default {
  title: {
    en: 'Please, confirm your data.'
  },

  confirm: {
    en: 'Confirm'
  },

  back: {
    en: 'Cancel'
  }
};
